import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=fec82f3e"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports